'use strict';

/**
 * Constant Service (wdConstantService.js).
 * Constant Service.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @copyright 2018 Webduct Systems Inc.
 *
 * @version
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */
angular.module('wd.service.constant', ['wd.helper.configuration', 'wd.helper.constants'])
    .factory('wdConstantService',
    ['$q', 'wdConstantHelper', 'wdConfigurationHelper', 'wdHttpService',
        function($q, wdConstantHelper, wdConfigurationHelper, wdHttpService) {

            /**
             * Service: Constants
             *
             * @since 1.0.0
             * @type {Object}
             */
            var service = {};

            /**
             * Initialize Constants
             *
             * @since 1.0.0
             * @returns {Q.Promise}
             */
            service.initialize = function () {

                var deferred = $q.defer();

                if (wdConfigurationHelper.getBaseApiPath()) {

                    wdHttpService.get(wdConfigurationHelper.getBaseApiPath() + 'constants')
                        .then(function (response) {

                            if (response) {

                                wdConstantHelper.setConstants(response.data);
                                deferred.resolve(response);

                            } else {

                                deferred.reject(response);

                            }

                        }, function (response) {

                            deferred.reject(response);

                        });

                } else {

                    deferred.resolve('Missing Base API Path; No Constants Available');

                }

                return deferred.promise;

            };

            return service;

        }]);

// EOF